import React, { useEffect, useState } from "react";
import uuid from "react-uuid";
import { Badge, Card, Form, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { FormHelper, StyleHelper } from "utils";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import Attachments from "components/Attachment/Attachment";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { ComprobanteElectronico } from "models/ECF/ComprobanteElectronico";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import { RncLookup } from "components";
import useQueryParams from "hooks/useQueryParams";
import { Compania } from "models/Compania";
import { CompaniaManager, SolicitudCompaniaTenantManager as SolicitudManager } from "managers";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import DropZone from "components/DropZone/Dropzone";
import { useTheme, useApp } from "hooks";
import useConfirm from "hooks/useConfirm";
import {
  ESTATUS_RECHAZADO,
  ESTATUS_RECHAZADO_LABEL
} from "models/SolicitudesCompaniaTenant"
import { InputSidebarContainer } from "components";
import ModalContainer from "components/ModalContainer/ModalContainer";
import { useAuthentication } from "hooks";

const ESTATUS_LIST = Compania.ESTATUS_LIST;
const AMBIENTES_LIST = Compania.AMBIENTE_LIST;

export default function CompaniaEdit({ showLoading, hideLoading }) {
  const CITRUS_ID = 10;

  const [compania, setCompania] = useState({});
  const [solicitud, setSolicitud] = useState({});
  const [companiasTenant, setCompaniasTenant] = useState([]);
  const [tituloHeader, setTituloHeader] = useState("Crear Compañia");
  const [mostrarConfiguracionSistemaExterno, setMostrarConfiguracionSistemaExterno] = useState(false);
  const [showRechazoSolicitudModal, setShowRechazoSolicitudModal] = useState();
  const [razonRechazoSolicitud, setRazonRechazoSolicitud] = useState();
  const [showAdjuntarDocumentosModal, setShowAdjuntarDocumentosModal] = useState();
  const [modal, setModal] = useState(false);
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [rncLookupKey, setRncLookupKey] = useState(uuid());
  const { usuario } = useAuthentication();

  const URLParameters = useQueryParams();
  const Id = URLParameters.get("Id");
  const request = URLParameters.get("request") === "true";
  const requestDataParam = URLParameters.get("requestData");
  const requestData = request ? JSON.parse(atob(requestDataParam)) : null;
  const requestId = request ? requestData.Id : null;
  const requestCompaniaId = request ? requestData.CompaniaId : null;
  const esNuevo = !Id;
  const { Message, cerrarAlertas, Types, Warning } = useMessage();
  const { Confirm } = useConfirm();
  const { handleException } = useExceptionHandler();
  const { theme, vendorTheme } = useTheme();
  const { configuration } = useApp();
  const history = useHistory();

  useEffect(() => {
    if (usuario?.CompaniaId !== CITRUS_ID) {
      Warning({ message: "Usuario no tiene permiso" });
      return;
    }

    if (Id) {
      showLoading();
      cargarCompania(Id);
      setTituloHeader("Editar Compañia");
    } else if (request) {
      cargarFormularioCompania(requestId, requestCompaniaId);
    } else {
      setDefaultValues();
    }

    const companiasTenantWhere = {
      EsTenant: true,
      EsPaginable: false,
      Estatus: "A"
    };
    CompaniaManager.listado(companiasTenantWhere)
      .then((res) => {
        const companiasTenant = [
          { label: "N/A", value: null },
          ...(res.Data?.map((cia) => ({
            label: `${cia.RNC} - ${cia.Nombre}`,
            value: cia.Id
          })) || [])
        ];
        setCompaniasTenant(companiasTenant);
      })
      .catch((err) => handleException(err));

    hideLoading();
    cerrarAlertas();
    return () => { };
  }, []);

  useEffect(() => {
  }, [compania]);

  const setDefaultValues = () => {
    let color1 = "#F16101";
    let color2 = "#8AA8B0";
    let color3 = "#FFFFFF";

    if (theme.title == "GN ECF") {
      color1 = "#D52B1E";
      color2 = "#1097AF";
      color3 = "#FFFFFF";
    }

    setCompania({
      ...Compania,
      Estatus: Compania.DEFAULT_ESTATUS_VALUE,
      Ambiente: Compania.DEFAULT_AMBIENTE_VALUE,
      Nombre: "",
      RazonSocial: "",
      Codigo: "",
      RNC: "",
      DireccionLinea1: "",
      TelefonoPrincipal: "",
      TelefonoSecundario: "",
      Email: "",
      Color1: color1,
      Color2: color2,
      Color3: color3,
      PaginaWeb: "",
      Extension1: "",
      Extension2: "",
      Fax: "",
      ConfiguracionSistemaExterno: "",
      ClienteId: 0,
      EsPrincipal: false,
      Logo: "",
      ManejarSecuenciasFiscalesAutomaticamente: true,
    });
    setMostrarConfiguracionSistemaExterno(false);
  };

  const onLogoChange = (files) => {
    const file = Array.isArray(files) ? files[0] : files;
    if (!file) {
      setCompania((prev) => ({ ...prev, Logo: null }));
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) =>
      setCompania((prev) => ({ ...prev, Logo: e.target.result }));
    reader.readAsDataURL(file);
  };

  const setCheckedProp = (e) => {
    const { name, checked } = e.target;
    setCompania({
      ...compania,
      [name]: checked,
    });
  };

  const cargarFormularioCompania = (requestId, requestCompaniaId) => {
    const request = {
      IdSec: requestId,
      CompaniaId: requestCompaniaId
    }
    SolicitudManager.buscarSolicitudCompaniaTenantPorId(request).then((data) => {
      data.compania.Color1 = "#" + data.compania.Color1;
      data.compania.Color2 = "#" + data.compania.Color2;
      data.compania.Color3 = "#" + data.compania.Color3;

      setCompania(data.compania);
      setSolicitud(data.solicitud);
    });
  }

  const cargarCompania = (Id) => {

    CompaniaManager.buscarPorId(Id).then((data) => {
      data.Color1 = "#" + data.Color1;
      data.Color2 = "#" + data.Color2;
      data.Color3 = "#" + data.Color3;

      setCompania({ ...data, Id });
      // Si hay configuración de sistema externo, marcar el checkbox
      if (data.ConfiguracionSistemaExterno && data.ConfiguracionSistemaExterno.trim() !== "") {
        setMostrarConfiguracionSistemaExterno(true);
      }
    });
  };

  const onFileChange = (propFile, propName) => {
    setCompania({ ...compania, [propName]: propFile });
  };

  function handleCrearEnProduccion(forzarIdAutomatico = false) {
    showLoading();
    CompaniaManager.crearEnProduccion(Id, forzarIdAutomatico)
      .then((res) => {
        if (res?.yaExiste) {
          Warning({ message: "Esta compañía ya está creada en producción." });
        } else if (res?.nombreOcupado) {
          Warning({ message: "Ya existe una compañía con este nombre en producción." });
        } else if (res?.idOcupado) {
          Confirm({
            title: "ID en uso",
            textBody: "Este ID ya está en uso por otra compañía en producción. ¿Desea crearla de todas formas con un ID autogenerado?",
            onConfirm: () => handleCrearEnProduccion(true),
            confirmBtnText: "Sí, crear",
            cancelBtnText: "Cancelar",
            showCancel: true,
          });
        } else {
          Message({ message: "Compañía creada exitosamente en producción." });
        }
      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  }

  function grabar() {
    showLoading();

    if (esNuevo) {
      let companiaRequest = {
        ...compania
      }
      if (request) {
        companiaRequest = {
          ...companiaRequest,
          EsSolicitudTenant: request,
          SolicitudId: requestId,
          CompaniaSolicitanteId: requestCompaniaId
        }
        setCompania(companiaRequest);
      }
      CompaniaManager.crear(companiaRequest)
        .then((_res) => {
          Message({ message: `Grabado Exitosamente` });
          if (request) {
            let urlBase = `/SolicitudCompaniaTenantList`;
            history.push(urlBase);
          }
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    } else {
      setCompania({ ...compania, Id: Id });
      CompaniaManager.editar(compania)
        .then(() => {
          Message({ message: `Actualizado Exitosamente` });
          cargarCompania(res.Id);
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    }
  }

  function rechazarSolicitud() {
    showLoading();

    if (request) {
      SolicitudManager
        .actualizarSolicitudCompaniaTenant({
          IdSec: requestId,
          CompaniaId: requestCompaniaId,
          Estatus: ESTATUS_RECHAZADO,
          RazonRechazoSolicitud: razonRechazoSolicitud
        })
        .then((res) => {
          Message({ message: "Solicitud rechazada exitosamente." });
        })
        .catch((err) => {
          handleException(err);
        })
        .finally(() => {
          hideLoading();
          setShowRechazoSolicitudModal(false);
          let urlBase = `/SolicitudCompaniaTenantList`;
          history.push(urlBase);
        });
    }
  }

  const rechazarSolicitudModal = (
    <ModalContainer
      showModal={showRechazoSolicitudModal}
      size="lg"
      title="Rechazar Solicitud"
      btnGrabar={{
        label: "Grabar",
        show: true
      }}
      cerrar={() => {
        setShowRechazoSolicitudModal(false);
      }}
      grabar={() => {
        rechazarSolicitud();
      }}
    >
      <EditSection>
        <Row>
          <InputSidebarContainer label="Razón de rechazo">
            <Form.Control
              as="textarea"
              rows={5}
              style={{ resize: "vertical" }}
              disabled={false}
              value={razonRechazoSolicitud}
              onChange={(e) =>
                setRazonRechazoSolicitud(e.target.value)
              }
            >
            </Form.Control>
          </InputSidebarContainer>
        </Row>
      </EditSection>
    </ModalContainer>
  )

  const adjuntarDocumentoModal = (
    <ModalContainer
      showModal={showAdjuntarDocumentosModal}
      size="lg"
      title="Adjuntar Documentos"
      btnGrabar={{
        show: false
      }}
      cerrar={() => {
        setShowAdjuntarDocumentosModal(false);
      }}
    >
      <EditSection>
        <Attachments
          readonly={true}
          showLoading={() => { }}
          hideLoading={() => { }}
          companiaId={solicitud.CompaniaId}
          fuente="SolicitudesCompaniaTenant"
          modulo="ECF"
          referencia={requestId}
          ocultarHeader={true}
          modal={modal}
          setModal={setModal}
          setAttachmentCount={setAttachmentCount}
        />
      </EditSection>
    </ModalContainer>
  )

  return (
    <>
      {request && showRechazoSolicitudModal && rechazarSolicitudModal}
      {request && showAdjuntarDocumentosModal && adjuntarDocumentoModal}

      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo={`${tituloHeader}`}
            volver={true}
            grabar={grabar}
            {...request && { rechazar: () => setShowRechazoSolicitudModal(true) }}
            {...request && { adjuntarDocumento: () => setShowAdjuntarDocumentosModal(true) }}
            {...(!esNuevo && !configuration?.EsProduccion && { crearEnProduccion: handleCrearEnProduccion })}
          />
          <EditContainer>
            <EditSection title="Información General" style={{}}>
              <SectionRow>
                <InputContainer stacked label="Id">
                  <Form.Control
                    type="number"
                    name="Id"
                    value={compania.Id}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={!esNuevo}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer stacked label="Documento">
                  <RncLookup
                    key={rncLookupKey}
                    required={true}
                    initialValue={{
                      value: compania.RNC ?? "",
                      label: compania.RNC ?? "",
                      Rnc: compania.RNC ?? "",
                      RazonSocial: compania.RazonSocial ?? "",
                      NombreComercial: compania.Nombre ?? ""
                    }}
                    onChange={(e) => {
                      setCompania({
                        ...compania,
                        RNC: e.Rnc,
                        RazonSocial: e.RazonSocial,
                        Nombre: e.NombreComercial
                      });
                    }}
                  />
                </InputContainer>

                <InputContainer stacked label="Razón Social">
                  <Form.Control
                    type="text"
                    name="RazonSocial"
                    value={compania.RazonSocial}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer stacked label="Nombre Comercial">
                  <Form.Control
                    type="text"
                    name="Nombre"
                    value={compania.Nombre}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>

                <InputContainer stacked label="Código">
                  <Form.Control
                    type="text"
                    name="Codigo"
                    value={compania.Codigo}
                    onChange={(e) =>
                      FormHelper.handleChangeNoEspace(e, setCompania)
                    }
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow multilinea>
                <InputContainer stacked label="Dirección">
                  <Form.Control
                    type="text"
                    name="DireccionLinea1"
                    value={compania.DireccionLinea1}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title="Información de Contacto" style={{}}>
              <SectionRow columns={3}>
                <InputContainer stacked label="Teléfono Principal">
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <Form.Control
                      type="text"
                      name="TelefonoPrincipal"
                      placeholder="Teléfono Principal"
                      value={compania.TelefonoPrincipal}
                      onChange={(e) =>
                        FormHelper.handleChangeSoloNumero(e, setCompania)
                      }
                      style={{ flex: 3 }}
                    />
                    <Form.Control
                      type="text"
                      name="Extension1"
                      placeholder="Ext."
                      value={compania.Extension1}
                      onChange={(e) =>
                        FormHelper.handleChangeSoloNumero(e, setCompania)
                      }
                      style={{ flex: 1 }}
                    />
                  </div>
                </InputContainer>

                <InputContainer stacked label="Teléfono Secundario">
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <Form.Control
                      type="text"
                      name="TelefonoSecundario"
                      placeholder="Teléfono Secundario"
                      value={compania.TelefonoSecundario}
                      onChange={(e) =>
                        FormHelper.handleChangeSoloNumero(e, setCompania)
                      }
                      style={{ flex: 3 }}
                    />
                    <Form.Control
                      type="text"
                      name="Extension2"
                      placeholder="Ext."
                      value={compania.Extension2}
                      onChange={(e) =>
                        FormHelper.handleChangeSoloNumero(e, setCompania)
                      }
                      style={{ flex: 1 }}
                    />
                  </div>
                </InputContainer>

                <InputContainer stacked label="Correo">
                  <Form.Control
                    type="text"
                    name="Email"
                    value={compania.Email}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow columns={3}>
                <InputContainer stacked label="Fax">
                  <Form.Control
                    type="text"
                    name="Fax"
                    value={compania.Fax}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>

                <InputContainer stacked label="Página Web">
                  <Form.Control
                    type="text"
                    name="PaginaWeb"
                    value={compania.PaginaWeb}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            {request && (
              <EditSection title="Información de Certificación de Facturación Electrónica" style={{}}>
                <SectionRow>
                  {solicitud.CantidadEnviosCredenciales > 0 ? (
                    <Badge
                      bg="success"
                      style={{ fontSize: "0.9rem", padding: "8px 12px", whiteSpace: "normal" }}
                    >
                      Credenciales cargadas: Sí — enviadas {solicitud.CantidadEnviosCredenciales}{" "}
                      {solicitud.CantidadEnviosCredenciales === 1 ? "vez" : "veces"}
                      {solicitud.FechaUltimoEnvioCredenciales
                        ? ` (última: ${new Date(
                          solicitud.FechaUltimoEnvioCredenciales
                        ).toLocaleDateString("es-DO", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })})`
                        : ""}
                    </Badge>
                  ) : (
                    <Badge
                      bg="secondary"
                      style={{ fontSize: "0.9rem", padding: "8px 12px" }}
                    >
                      Credenciales cargadas: No
                    </Badge>
                  )}
                </SectionRow>
              </EditSection>
            )}

            <EditSection title="Otras Informaciones" style={{}}>
              <SectionRow columns={6}>
                <InputContainer stacked label="Cantidad de PT">
                  <Form.Control
                    type="number"
                    name="CantidadPT"
                    value={compania.CantidadPT}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title="Configuración de la Apariencia" style={{}}>
              <SectionRow columns={3}>
                <InputContainer stacked label="Logo">
                  {compania.Logo && (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 8 }}>
                      <img
                        src={compania.Logo}
                        alt="Logo"
                        style={{ maxHeight: 80 }}
                      />
                      <i
                        className="fa fa-trash"
                        role="button"
                        title="Eliminar logo"
                        onClick={() => onLogoChange(null)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  )}
                  <DropZone
                    label="Seleccionar Imagen"
                    updateFilesCb={(f) => onLogoChange(f)}
                    multiple={false}
                    type="image"
                    showFiles={false}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title="Colores del Menú" style={{}}>
              <SectionRow triple={true}>
                <InputContainer stacked label="Primario" labelSize={3}>
                  <Form.Control
                    name="Color1"
                    type="color"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.Color1}
                  />
                </InputContainer>
                <InputContainer stacked
                  label="Secundario"
                  labelSize={3}
                  labelClassName="pl-2 d-flex"
                >
                  <Form.Control
                    name="Color2"
                    type="color"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.Color2}
                  />
                </InputContainer>
                <InputContainer stacked label="Logo">
                  <Form.Control
                    name="Color3"
                    type="color"
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    value={compania.Color3}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title="Configuración de Facturación" style={{}}>
              <SectionRow multilinea>
                <InputContainer>
                  <div style={{ display: "flex", gap: "1.5rem" }}>
                    <Form.Check
                      id="chkManejarSecuenciasFiscalesAutomaticamente"
                      type="checkbox"
                      name="ManejarSecuenciasFiscalesAutomaticamente"
                      checked={compania.ManejarSecuenciasFiscalesAutomaticamente || false}
                      onChange={setCheckedProp}
                      label="Manejar Secuencias Fiscales Automaticamente"
                    />
                  </div>
                </InputContainer>
              </SectionRow>

              <SectionRow multilinea>
                <InputContainer>
                  <div style={{ display: "flex", gap: "1.5rem" }}>
                    <Form.Check
                      id="chkNoPermitirDuplicadoFacturaInterna"
                      type="checkbox"
                      name="NoPermitirDuplicadoFacturaInterna"
                      checked={compania.NoPermitirDuplicadoFacturaInterna || false}
                      onChange={setCheckedProp}
                      label="No permitir Duplicado Numero Factura Interna"
                    />
                  </div>
                </InputContainer>
              </SectionRow>

              <SectionRow multilinea>
                <InputContainer>
                  <div style={{ display: "flex", gap: "1.5rem" }}>
                    <Form.Check
                      id="chkMostrarConfiguracionSistemaExterno"
                      type="checkbox"
                      checked={mostrarConfiguracionSistemaExterno || false}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setMostrarConfiguracionSistemaExterno(checked);
                        if (!checked && compania.ConfiguracionSistemaExterno) {
                          setCompania({
                            ...compania,
                            ConfiguracionSistemaExterno: ""
                          });
                        }
                      }}
                      label="Agregar Configuración de Sistema Externo"
                    />
                  </div>
                </InputContainer>
              </SectionRow>

              {mostrarConfiguracionSistemaExterno && (
                <SectionRow multilinea>
                  <InputContainer stacked label="Configuración Sistema Externo">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="ConfiguracionSistemaExterno"
                      value={compania.ConfiguracionSistemaExterno || ""}
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      placeholder="Ingrese la configuración JSON del sistema externo..."
                    />
                  </InputContainer>
                </SectionRow>
              )}

              <SectionRow columns={4}>
                <InputContainer>
                  <div style={{ display: "flex", gap: "1.5rem" }}>
                    <Form.Check
                      id="chkEsPrincipal"
                      type="checkbox"
                      name="EsPrincipal"
                      checked={compania.EsPrincipal || false}
                      onChange={setCheckedProp}
                      label="Es Principal"
                    />
                  </div>
                </InputContainer>

                <InputContainer stacked label="Cliente ID">
                  <Form.Control
                    type="number"
                    name="ClienteId"
                    value={compania.ClienteId}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow columns={4}>
                <InputContainer stacked label="Cantidad de Transacciones">
                  <Form.Control
                    type="number"
                    name="CantidadTransacciones"
                    value={compania.CantidadTransacciones}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title=" Detalles de Vinculación" style={{}}>
              <SectionRow multilinea>
                <InputContainer>
                  <div style={{ display: "flex", gap: "1.5rem" }}>
                    <Form.Check
                      id="chkEsTenant"
                      type="checkbox"
                      name="EsTenant"
                      checked={compania.EsTenant || false}
                      onChange={setCheckedProp}
                      label="Es Padre"
                      disabled={request}
                    />
                  </div>
                </InputContainer>
              </SectionRow>

              {!(compania.EsTenant ?? false) &&
                <SectionRow>
                  <InputContainer stacked label="Compañía Padre">
                    <Select
                      isDisabled={request}
                      className="react-select primary mb-2"
                      classNamePrefix="react-select"
                      name="CompaniaTenantId"
                      onChange={(e) => {
                        setCompania({
                          ...compania,
                          CompaniaTenantId: e.value
                        });
                      }}
                      options={companiasTenant}
                      value={companiasTenant.filter(c => c.value == compania.CompaniaTenantId)}
                    />
                  </InputContainer>
                </SectionRow>
              }
            </EditSection>
          </EditContainer>
        </Card>
      </Form >
    </>
  );
}
